<template>
  <div>
    <a-modal title="关联业务需求" :visible="visible" :confirm-loading="loading" @cancel="onClose" @ok="onSubmit">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item ref="requirementId" label="关联需求" prop="requirementId">
          <business-requirement-select ref="bssReqRef" v-model="form.requirementId" :status="[131]" :item-disabled="true" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { associateDocument } from '@/api/business/document';
import BusinessRequirementSelect from '@/pages/business/document/components/BusinessRequirementSelect';

export default {
  components: { BusinessRequirementSelect },
  data() {
    return {
      loading: false,
      visible: false,
      form: {
        documentId: null,
        requirementId: null
      },
      rules: {
        requirementId: [{ required: true, message: '关联需求不能为空', trigger: 'change' }]
      }
    };
  },
  methods: {
    onClose() {
      this.visible = false;
      this.loading = false;
      this.$refs.form.resetFields();
    },

    onOpen(documentId) {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.bssReqRef.init();
      });
      this.form = { documentId: documentId, requirement_id: null };
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          associateDocument({ ...this.form })
            .then(() => {
              this.loading = false;
              this.visible = false;
              this.$message.success('关联成功');
              this.$emit('reload');
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>
